export default {
  'identifyingLogicaOrder': {
    'course-title': 'Identifying Logical Order',
    'course-name': 'Section 6a <span class="unit-title">Identifying Logical Order<span>',
    'course-video': {
      'title': '',
      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
      'lecture-title': ''
    },
    exercises: {
      title: '6A Exercises',
      description: ``,
      exercises16: 'Exercise 1-6',
    },
    'congratulation-message': 'THANK YOU',
    'finish-section': 'You have completed Section 6A',
    'final-description': 'You can easily identify the logical order of a set of ideas',
    'next-course-button': 'proceed to 6b',
    'dashboard-button': 'Main menu',
  }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/6/identifyingLogicaOrder/i18n/en.js